var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-checkbox',_vm._g({staticClass:"editor-expando py-0 my-1 mr-2",attrs:{"input-value":_vm.expandAll,"hide-details":"","label":"Expand all"},on:{"change":_vm.toggleExpandAll}},on))]}}])},[_c('span',[_vm._v("Expands all slides, not just the active one.")])])}
var staticRenderFns = []

export { render, staticRenderFns }